import { Image, Row } from "react-bootstrap";

const CollaboratorNoTable = ({ person }) => {
    return (
        <>
            <Row className="picture">
                <Image src={person.image} className="mx-auto d-block" />
            </Row>
            <Row className="profile text-center">
                <h1>{person.name}</h1>
                <p>{person.position}</p>
                <p>
                    <span className="proyects">{person.proyects}</span>
                </p>
            </Row>
        </>
    );
};

export default CollaboratorNoTable;
